import { isViewsLoading } from './meta.tsx';
import { createViewHook } from './utils.tsx';

export const useIsViewsLoading = createViewHook(isViewsLoading);
